import { createOrdenEstacionesCustom } from "./ordenEstaciones";
import ListaEstaciones from "./listaEstaciones";
import StateListaObjetosConId from "../tipos/stateListaObjetosConId"
import {TRISTATE_CUALQUIERA,TRISTATE_NO} from "../../utils/triStateUtils"
import FiltroEstaciones from "./filtrosEstaciones"
import OrdenEstaciones from "./ordenEstaciones"

class EstacionesState extends StateListaObjetosConId {

  /**
   * @param {import('./listaEstaciones').default} listaEstaciones
   * @param {import('./filtrosEstaciones').default} filtros
   */
  constructor(listaCompleta) {
    super(listaCompleta);
    this._orden= createOrdenEstacionesCustom()
    this._ordenadas.sort(this._orden)
  }

  /**
   * @returns Retorna la lista de estaciones ordenada y filtrada segun los parametros definidos actualmente.
   */
  getOrdenadasFiltradas() {
    return this._ordenadas.intersect(this._filtradas,ListaEstaciones);
  }
}

function crearEstacionesState(estaciones, gerencias, automaticas, convencionales) {
  return new EstacionesState(estaciones)
    .setOrden(new OrdenEstaciones())
    .setFiltros(
      new FiltroEstaciones(
        gerencias,
        automaticas ? TRISTATE_CUALQUIERA : TRISTATE_NO,
        convencionales ? TRISTATE_CUALQUIERA : TRISTATE_NO
      )
    );
}

export { EstacionesState as default, crearEstacionesState };
